/* D - hide the empty-cart state while a cart add is in flight. */
(function(){
  var h=document.documentElement;
  document.addEventListener('click',function(e){
    var t=e.target;if(!t||!t.closest)return;
    if(!t.closest('.fhbm__cta,.fhcd__upg,[name="add"],.product-form__submit'))return;
    h.classList.add('fh-cart-busy');
    var t0=Date.now(),iv=setInterval(function(){
      if(document.querySelector('.fhcd__item')||Date.now()-t0>7000){clearInterval(iv);h.classList.remove('fh-cart-busy');}
    },100);
  },true);
})();

/* F/K - sleep-mask pre-tick, collapsed colors, untick prompt on the lander.

   R (cart-drawer remove prompt) is ON again (2026-09-13), rebuilt on exact
   button identity - see below.
   S (live "EXTRA $X OFF" pill) was REMOVED: it wrote into .fhbm__aprice, inside
   the node this file's MutationObserver watches, so every write re-triggered
   the observer and locked the page up. That figure belongs in the section's
   own render (fhm-bundle-m1.liquid), not bolted on from outside.

   NOTE: pre-ticking a paid add-on is prohibited in the EU/UK (Consumer Rights
   Directive Art. 22). Runs in all markets at Nadav's explicit instruction
   (2026-09-12). To comply, gate on Shopify.country === 'US'. */
(function(){
  var MASK=/sleep mask/i;
  /* Real before/after pair supplied by Nadav 2026-09-12. &width=420 lets the
     Shopify CDN resize - the originals are ~190 KB each. */
  var IMG_A='https://cdn.shopify.com/s/files/1/0818/3060/9177/files/ChatGPT_Image_Sep_12_2026_05_31_31_PM.webp?v=1789225548&width=420';
  var IMG_B='https://cdn.shopify.com/s/files/1/0818/3060/9177/files/ChatGPT_Image_Sep_12_2026_05_33_14_PM.webp?v=1789225542&width=420';

  function dialog(opts){
    var ov=document.createElement('div');ov.className='fhmk__ov';
    ov.innerHTML='<div class="fhmk__bx" role="dialog" aria-modal="true">'
      +'<div class="fhmk__imgs">'
      +'<figure><img src="'+IMG_A+'" loading="eager" alt="Traveler squinting under the cabin lights without a sleep mask"><span class="fhmk__cap">Without</span></figure>'
      +'<figure><img src="'+IMG_B+'" loading="eager" alt="Traveler asleep wearing the FlyHugz sleep mask"><span class="fhmk__cap">With</span></figure>'
      +'</div>'
      +'<p class="fhmk__t">Do you really want to sleep with annoying lights?</p>'
      +'<p class="fhmk__s"></p>'
      +'<button type="button" class="fhmk__y"></button>'
      +'<button type="button" class="fhmk__n"></button></div>';
    ov.querySelector('.fhmk__s').textContent=opts.sub||'87% of travelers add the mask. Blocking the cabin lights is what lets you actually sleep.';
    ov.querySelector('.fhmk__y').textContent=opts.yes;
    ov.querySelector('.fhmk__n').textContent=opts.no;
    document.body.appendChild(ov);
    function close(){if(ov.parentNode)ov.parentNode.removeChild(ov);}
    ov.querySelector('.fhmk__y').addEventListener('click',function(){close();if(opts.onYes)opts.onYes();});
    ov.querySelector('.fhmk__n').addEventListener('click',function(){close();if(opts.onNo)opts.onNo();});
    ov.addEventListener('click',function(e){if(e.target===ov){close();if(opts.onNo)opts.onNo();}});
  }

  setTimeout(function(){try{new Image().src=IMG_A;new Image().src=IMG_B;}catch(e){}},2500);

  /* ===================== R: drawer "remove sleep mask" prompt =====================
     History: two earlier versions matched on TEXT ("sleep mask") by walking up the
     DOM, and fired when removing a PILLOW because the drawer groups add-ons with
     their bundle. That blocked customers from editing their cart, so it was pulled.
     This version matches ONLY buttons whose own identity says "mask":
       1. the mask add-on box's Remove      [data-fhc-krem][data-kk="mask"]
       2. its minus button on the LAST mask [data-fhc-kdec][data-kk="mask"] with qty 1
       3. a standalone mask line (a .fhcd__item[data-key] - one cart line, never a
          group) whose own product link is the mask: its Remove, or minus at qty 1
     Pillow rows, bundle groups and every other product never match. Choosing
     "Remove" replays the original click, so removing always still works. */
  var MASK_URL='/products/flyhugz-premium-sleep-mask';
  function maskRemoveTarget(t){
    var b=t.closest('[data-fhc-krem][data-kk="mask"]');
    if(b)return b;
    b=t.closest('[data-fhc-kdec][data-kk="mask"]');
    if(b){var n=b.parentNode&&b.parentNode.querySelector('b');return (n&&String(n.textContent).trim()==='1')?b:null;}
    b=t.closest('[data-fhc-rm],[data-fhc-dec]');
    if(!b)return null;
    var line=b.closest('.fhcd__item[data-key]');
    if(!line||line.hasAttribute('data-gid'))return null;
    var link=line.querySelector('a.fhcd__name');
    if(!link||(link.getAttribute('href')||'').indexOf(MASK_URL)<0)return null;
    if(b.hasAttribute('data-fhc-dec')){var q=b.parentNode&&b.parentNode.querySelector('span');if(!q||String(q.textContent).trim()!=='1')return null;}
    return b;
  }
  window.addEventListener('click',function(e){
    var t=e.target;if(!t||!t.closest)return;
    var b=maskRemoveTarget(t);if(!b)return;
    if(b.__fhBypass){b.__fhBypass=false;return;}
    e.preventDefault();e.stopImmediatePropagation();
    dialog({yes:'Keep my sleep mask',no:'Remove it',
      sub:'Cabin lights and screens are what keep you awake. 87% of travelers keep the mask.',
      onNo:function(){if(document.contains(b)){b.__fhBypass=true;b.click();}}});
  },true);

  /* ---------- lander only ---------- */
  var HANDLES=['flyhugz-exclusive-bogo-deals','the-original-flyhugz-travel-pillow-2026'];
  /* 7-reasons advertorials sell the same pillow + Buy 1 Get 1 mask, so they get the pre-tick and the untick prompt too */
  if(!HANDLES.some(function(h){return location.pathname.indexOf('/products/'+h)>-1;})&&!/\/pages\/7-reasons-/.test(location.pathname))return;
  var armed=false,shown=false,userOpened=false;

  /* Match the mask add-on by its data-addon key first: on translated pages (/he etc.) the visible
     name is no longer "Sleep Mask", so text matching silently disabled the pre-tick and its popup. */
  function isMaskAddon(el){return !!el&&(el.getAttribute('data-addon')==='mask'||MASK.test(el.innerText||''));}
  function addon(){
    var k=document.querySelector('.fhbm__addon[data-addon="mask"]');if(k)return k;
    var l=document.querySelectorAll('.fhbm__addon');
    for(var i=0;i<l.length;i++){if(MASK.test(l[i].innerText||''))return l[i];}
    return null;
  }
  function on(el){return !!(el&&el.classList.contains('on'));}
  function toggle(el){var r=el&&el.querySelector('.fhbm__arow');if(r)r.click();}

  /* Only ever ADDS a class and one button - never writes text into nodes the
     observer watches, so it cannot feed itself. */
  function collapse(){
    var a=addon();
    if(!a||!on(a))return;
    if(!a.querySelector('.fhbm__astrip'))return;
    if(!userOpened&&!a.classList.contains('fhmk-col'))a.classList.add('fhmk-col');
    if(a.querySelector('.fhmk__coltog'))return;
    var b=document.createElement('button');
    b.type='button';b.className='fhmk__coltog';
    b.textContent=userOpened?'Hide colors':'Choose mask colors';
    b.addEventListener('click',function(e){
      e.preventDefault();e.stopPropagation();
      var el=addon();if(!el)return;
      userOpened=!el.classList.toggle('fhmk-col');
      b.textContent=userOpened?'Hide colors':'Choose mask colors';
    });
    a.appendChild(b);
  }

  var tries=0,iv=setInterval(function(){
    if(++tries>60){clearInterval(iv);return;}
    var a=addon();if(!a)return;
    clearInterval(iv);
    /* no pre-select (owner 14.9): most buyers skip the mask, so it starts unticked */
    setTimeout(function(){collapse();armed=true;},1600);
  },200);

  var mo=new MutationObserver(function(){collapse();});
  setTimeout(function(){
    var k=document.querySelector('.fhbm__kit');
    if(k)mo.observe(k,{childList:true,subtree:true});
  },1500);

  document.addEventListener('click',function(e){
    if(!armed||shown)return;
    var t=e.target;if(!t||!t.closest)return;
    if(t.closest('.fhmk__coltog')||t.closest('.fhbm__astep'))return;
    var row=t.closest('.fhbm__arow');if(!row)return;
    var a=row.closest('.fhbm__addon');
    if(!isMaskAddon(a))return;
    if(!on(a))return;
    setTimeout(function(){
      var c=addon();
      if(c&&!on(c)){
        shown=true;
        dialog({yes:'Yes, add it back',no:'No thanks',
          onYes:function(){var x=addon();if(x&&!on(x)){toggle(x);setTimeout(collapse,700);}}});
      }
    },450);
  },true);
})();
